<template>
  <div class="userPage">
    <b-row class="pageTitle">
      <b-col cols="12" class="d-flex mb-3">
        <h3 class="m-0">Danh sách cổ phiếu</h3>
      </b-col>
    </b-row>
    <b-row v-if="isAdmin">
      <b-col cols="12">
        <transition name="slide">
          <b-card>
            <div slot="header">
              <b-row align-h="between">
                <b-col class="justify-content-start d-flex">
                  <div v-if="pages" class="result-area">
                    <i>Kết quả: <b>{{ pages.total }}</b> mã cổ phiếu.</i>
                  </div>
                </b-col>

                <b-col class="justify-content-end d-flex">
                  <b-button class="mr-5" size="sm" text="Button" variant="primary" type="submit"
                            @click.prevent="showHiddenList()"
                  >
                    <i class="icon-list icons font-lg  pl-1 pr-1"></i>

                    <span v-if="!listHiddenShow">Xem danh sách CP đã ẩn</span>
                    <span v-else>Xem toàn bộ CP</span>
                  </b-button>

                  <div class="search-area">
                    <b-form @submit="searchForm" class="justify-content-end d-flex">
                      <b-input-group class="mb-0">
                        <b-form-input v-model="filter.search" placeholder="Tìm kiếm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" text="Button" variant="primary" type="submit">
                            <i class="icon-magnifier icons font-lg  pl-1 pr-1"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form>
                  </div>
                </b-col>
              </b-row>

            </div>
            <div v-if="data.length" v-bind:class="{'ptt-loading':loading}">
              <b-table bordered responsive="sm" :items="data" :fields="fields" :hover="true">
                <template slot="code" slot-scope="option">
                  <strong>
                    <b-link :to="{ path: '/stock/' + option.item._id}">{{ option.item.code }}</b-link>
                  </strong>
                </template>
                <template slot="isEnable" slot-scope="option">
                  <template v-if="option.item.isEnable === true">
                    <span class="badge badge-success"><i class="fa fa-eye"></i></span>
                    <a class="toggle" @click.prevent="setEnable(option.item)"><i class="fa fa-toggle-off fa-lg"></i></a>
                  </template>
                  <template v-else>
                    <span class="badge badge-danger"><i class="fa fa-eye-slash"></i></span>
                    <a class="toggle" @click.prevent="setEnable(option.item)"><i class="fa fa-toggle-on fa-lg"></i></a>
                  </template>

                </template>

                <template slot="isAutoHide" slot-scope="option">
                  <template v-if="option.item.isAutoHide > 0">
                    <span class="badge badge-danger"><i class="fa fa-close "></i> Đã ẩn</span>
                  </template>
                  <template v-else>
                    <span class="badge badge-success"><i class="fa fa-check"></i> Đã hiện</span>
                  </template>

                </template>

                <template slot="isEnoughFinData" slot-scope="option">
                  <template v-if="option.item.isEnoughFinData === false">
                    <span class="text-danger">false</span>
                  </template>
                  <template v-else>
                    <span class="text-success">true</span>
                  </template>

                </template>

              </b-table>
              <nav v-if="pages && pages.totalPages >1" class="d-flex justify-content-center">
                <b-pagination size="sm" :total-rows="pages.total * 2" :per-page="limit" v-model="pages.page"/>
              </nav>
            </div>
            <div v-bind:class="{'ptt-loading':loading}" v-else>
              <b-alert show variant="warning">Không có cổ phiếu</b-alert>
            </div>
          </b-card>
        </transition>
      </b-col>

      <b-col cols="12" v-if="isSuperAdmin && indexBFieldLoading === false">
        <transition name="slide-2">
          <b-card ref="indexBForm">
            <div slot="header">
              <h5>Danh sách cổ phiểu - Trọng số B</h5>
            </div>
            <b-form id="indexBForm" @submit="saveIndicesB" >
              <b-row v-if="indexBValues">
                <b-col>
                  <b-table small hover :items="columns[0]" :fields="indexBColumns" responsive="sm">
                    <template slot="label" slot-scope="option">
                      {{option.item.label|removeBr}}
                    </template>
                    <template slot="value" slot-scope="option">
                      <IndexBBox :field="option.item" @changed="indexBChanged" :disabled="indexBFieldDisabled" />
                    </template>
                  </b-table>
                </b-col>
                <b-col>
                  <b-table small hover :items="columns[1]" :fields="indexBColumns" responsive="sm">
                    <template slot="label" slot-scope="option">
                      {{option.item.label|removeBr}}
                    </template>
                    <template slot="value" slot-scope="option">
                      <IndexBBox :field="option.item" @changed="indexBChanged" :disabled="indexBFieldDisabled" />
                    </template>
                  </b-table>
                </b-col>
                <b-col>
                  <b-table small hover :items="columns[2]" :fields="indexBColumns" responsive="sm">
                    <template slot="label" slot-scope="option">
                      {{option.item.label|removeBr}}
                    </template>
                    <template slot="value" slot-scope="option">
                      <IndexBBox :field="option.item" @changed="indexBChanged" :disabled="indexBFieldDisabled" />
                    </template>
                  </b-table>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col align="right">
                  <b-button variant="danger" class="resetIndicesB mr-2" @click.prevent="resetIndicesB" :disabled="indexBFieldDisabled">Đặt lại</b-button>
                  <b-button variant="success" class="saveIndicesB"  @click.prevent="saveIndicesB" :disabled="indexBFieldDisabled">Lưu thay đổi</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <b-row v-else>
      <p class="alert alert-warning">Bạn không có quyền truy cập mục này.</p>
    </b-row>
  </div>

</template>

<script>
import accounting from "accounting"
import Vue from "vue";

import {isAuth, isSuperAdmin, getUser} from "@/utils/auth";
import fields from "@/utils/fields";

import IndexBBox from "@/components/IndexBBox";

export default {
  name: 'StockList',
  components: {IndexBBox},
  data: () => {
    return {
      isAuth: true,
      data: [],
      pages: {
        page: 1
      },
      limit: 20,
      action: 0,
      actions: [
        "Hành động",
        "Xóa các lựa chọn"
      ],
      fields: [
        {key: "code", label: "Mã cổ phiếu"},
        {key: "CompanyName", label: "Tên công ty"},
        {key: "GiaCoPhieu", label: "Giá cổ phiếu (đ)", formatter: val => accounting.formatNumber(val, 0), tdClass:'text-right'},
        {key: "KhoiLuongKhopLenhHienTai", label: "KL Khớp lệnh", formatter: val => accounting.formatNumber(val, 0), tdClass:'text-right'},
        {key: "isEnable", label: "isEnable"},
        {key: "isAutoHide", label: "isAutoHide"},
        {key: "isEnoughFinData", label: "isEnoughFinData"},
      ],
      selected: [],
      selectAll: false,
      loading: false,
      listHiddenShow: false,
      filter: {
        search: '',
        status: null,
        statusArr: [
          {value: null, text: 'Chọn trạng thái'},
          {value: 1, text: 'Đang hoạt dộng'},
          {value: 2, text: 'Ngừng hoạt động'},
        ]
      },
      q: {
        "CompanyName": {$ne: null},
        "code": {$exists: true},
      },
      indexBFields: fields,
      indexBColumns: [
        {key: "order", label: "STT"},
        {key: "label", label: "Tiêu chí"},
        {key: "value", label: "Trọng số B", thClass:'text-right',tdClass:'text-right'},
      ],
      indexBValues: null,
      indexBFieldLoading: false,
      indexBChangedFields: [],
      indexBFieldDisabled: false,
    }
  },
  watch: {
    "pages.page": function (val) {
      this.getData(val);
    },
    "filter.status": function (val) {
      if (val) {
        this.q["status"] = val;
      } else {
        delete this.q.status;
      }
      this.getData();
    }
  },
  computed: {
    isAdmin() {
      return isAuth()
    },
    isSuperAdmin() {
      return isSuperAdmin()
    },
    columns() {
      const col1 = [];
      const col2 = [];
      const col3 = [];

      this.indexBFields.forEach(item => {
        let order = parseInt(item.order)
        if (order >= 1 && order <= 32) {
          col1.push(item);
        } else if (order >= 33 && order <= 64) {
          col2.push(item);
        } else if (order >= 65 && order <= 98) {
          col3.push(item);
        }
      });

      return [col1, col2, col3];
    }

  },
  created() {
    this.getData()
    if (isSuperAdmin()) {
      setTimeout(() => this.getIndexBValue(), 300)
    }

  },
  methods: {
    async getData(page = null) {
      this.loading = true;
      try {
        let params = {
          fields: '_id,code,GiaCoPhieu,KhoiLuongKhopLenhHienTai,San,CompanyName,isEnable,isAutoHide,isEnoughFinData',
          sort: 'code',
          query: {
            code: {$ne: null}
          }
        }
        if (page > 0) {
          params.page = page
        }

        if (this.filter.search !== '') {
          params.search = this.filter.search
        }

        params.query = JSON.stringify(params.query)

        // Gửi yêu cầu API bằng Axios và đưa token vào header
        const {data} = await this.$axios.get(this.$configs.api + '/api/v1/cp/stocks', {params});

        const user = this.$cookies.get('user');
        this.$gtag.event('get_stock_list', {
          event_category: 'list_events',
          event_label: 'List stocks',
          user_type: 'admin',
          user_id: user?._id,
          qs: JSON.stringify(params) || null
        });
        if (data) {
          this.pages = data

        }
        if (data && data.rows) {
          this.data = data.rows
        }
        if (data && data.totalPages) {
          this.pages.count = data.totalPages
        }
      } catch (err) {
        // Kiểm tra xem có lỗi phản hồi từ máy chủ không
        if (err.response && (err.response.status === 500 || err.response.status !== 200)) {
          this.$toasted.error(err.response.data.message || "Đã xảy ra lỗi không mong muốn từ máy chủ", {
            duration: 5000
          });
        } else {
          // Xử lý các lỗi khác
          this.$toasted.error(err.message, {
            duration: 5000
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async getIndexBValue(code = "VNM") {
      this.indexBFieldLoading = true;
      try {
        let params = { code };
        const { data } = await this.$axios.get(this.$configs.api + '/api/v4/indices/get-index-b', { params });
        if (data?.result) {
          this.indexBValues = data.result;

          const processColumn = (column) => {
            if (column) {
              for (const indexBField of column) {
                const _key = `${indexBField?.key}_B`;
                // Kiểm tra this.indexBValues có phải object, nếu nó tồn tại property `${indexBField.key}_B`
                // thì gán indexBField.value = this.indexBValues[_key] tương ứng
                if (this.indexBValues && typeof this.indexBValues === 'object' && _key in this.indexBValues) {
                  indexBField.value = this.indexBValues[_key];
                }
              }
            }
          };

          // Process each column
          for (const column of this.columns) {
            processColumn(column);
          }
        }
      } catch (e) {
        // Handle error if necessary
        console.error(e);
      } finally {
        this.indexBFieldLoading = false;
      }
    },

    selectAllToggle() {
      this.selected = [];
      if (!this.selectAll) {
        for (let index in this.data) {
          this.selected.push(this.data[index]._id);
        }
      }
    },
    searchForm(evt) {
      evt.preventDefault();
      this.pages.page = 1 // reset về trang đầu
      const user = Vue.$cookies.get('user');
      this.$gtag.event('click_search', {
        event_category: 'click_events',
        event_label: 'Search stock',
        user_type: 'admin',
        user_id: user?._id,
        filter_search: this.filter.search
      });
      this.getData();
    },
    showHiddenList() {
      this.listHiddenShow = !this.listHiddenShow

      if (this.listHiddenShow) {
        this.q = {
          ...this.q,
          "isEnable": {$exists: true, $eq: !this.listHiddenShow},
        }
      } else {
        delete this.q.isEnable
      }
      const user = this.$cookies.get('user');
      this.$gtag.event('click_toggle_stock', {
        event_category: 'browser_events',
        event_label: 'Toggle stock status',
        user_type: 'admin',
        user_id: user?._id,
        filter_search: this.filter.search,
        filter_status: this.listHiddenShow
      });

      this.getData();
    },
    deleteData(id) {
      let ids = [];
      if (id) {
        ids.push(id);
      } else {
        if (this.selected.length) {
          ids = this.selected;
        } else {
          this.$toasted.show("Vui lòng chọn dữ liệu cần xóa", {
            type: "error",
            duration: 5000
          });
          return false;
        }
      }

      //Xoa du lieu
      this.$toasted.show("Bạn có chắc chắn muốn xóa", {
        type: "info",
        theme: "outline",
        duration: 10000,
        action: [
          {
            text: 'Hủy',
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          },
          {
            text: 'Xóa',
            // router navigation
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
              this.deleteAction(ids);
            }
          }
        ]
      })
    },
    deleteAction(ids) {
      this.$http.delete(this.$configs.api + '/api/user', {
        data: {ids}
      })
        .then(respons => {
          this.getData();
          this.$toasted.success("Xóa thành công", {
            duration: 5000
          });
        })
        .catch(err => {
          this.$toasted.error(err.message, {
            duration: 5000
          });
        });
    },
    runAction() {
      switch (this.action) {
        case 1:
          this.deleteData();
        default:
          return;
      }
    },
    async setEnable(item) {
      if (item && item._id) {

        const isEnable = item.isEnable !== true
        const params = {
          id: item._id,
          isEnable
        }

        try {
          const {data} = await this.$axios.get(this.$configs.api + '/api/v1/cp/stocks/set', {params});
          if (data?.id && data?.result) {
            this.updateStatItem(data.result)
          }
        } catch (e) {
          console.log(e)
        }
      }

    },
    updateStatItem(item) {
      if (item?.code) {
        const foundIndex = this.data.findIndex(x => x.code === item.code);
        if (foundIndex !== -1) this.data[foundIndex].isEnable = item.isEnable;
      }
    },
    async saveIndicesB(event = null) {

      if (this.indexBChangedFields?.length > 0) {
        this.indexBFieldDisabled = "disabled"
        try {
          let params = {
            fields: this.indexBChangedFields
          }
          let {data} = await this.$axios.post(this.$configs.api + '/api/v4/indices/save-index-b', params)

          if (data?.status === true) {
            this.$toasted.info("Đã lưu thay đổi Trọng số B", {
              duration: 2000
            });
            this.resetIndicesB(false)
          }

        } catch (e) {
          this.$toasted.error("Đã có lỗi khi lưu thay đổi Trọng số B", {
            duration: 2000
          });
        } finally {
          setTimeout(() => {this.indexBFieldDisabled = null}, 500)
        }
      }
    },
    resetIndicesB (toasted=true) {
      this.getIndexBValue()
      this.scrollToForm(toasted);
    },
    scrollToForm(toasted=true) {
      const form = this.$refs.indexBForm;
      if (form) {
        form.scrollIntoView({ behavior: 'smooth' });
        if (toasted) {
          this.$toasted.info("Đã đặt lại danh sách Trọng số B", {
            duration: 2000
          });
        }

      }
    },
    indexBChanged(prop) {
      if (prop?.key && (prop?.value || prop.value === 0)) {
        if (this.indexBChangedFields) {
          let index = this.indexBChangedFields.findIndex(item => item?.key===prop.key)
          if (index <0) {
            this.indexBChangedFields.push(prop)
          } else {
            this.indexBChangedFields[index].value = prop.value
          }
        }
      }
    }

  },
  filters: {
    removeBr(value) {
      if (!value) return '';
      return value.replace(/<br\s*\/?>/gi, ' '); // Thay thế bằng dấu cách hoặc '\n' cho xuống dòng
    }
  },
}
</script>
<style>
a.toggle {
  margin: 0 5px;
  color: #869fac;
  cursor: pointer;
}

a.toggle i {
  color: #869fac;
}
.resetIndicesB[disabled],.saveIndicesB[disabled] {
  pointer-events: none!important;
}
</style>
